// Admin auth gate (Slice 2 CP1 placeholder).
//
// The production gate is a Cloudflare Worker in front of this SPA
// (see workers/admin-gate/). That Worker validates a signed cookie
// and redirects unauthenticated requests to a login page.
//
// Inside the SPA we only need a thin runtime check: is the gate cookie
// present? If not, render the NotAuthed view rather than attempting to
// fetch Worker endpoints that would 401 anyway. The real enforcement
// happens at the Worker gate, not here.
//
// For CP1 the cookie name is read but not cryptographically validated;
// the Worker gate is the authority. This file exists so we can swap in
// a real identity call later (/me or similar) without restructuring
// callers.

const ADMIN_COOKIE = 'fishstank_admin'

export function hasAdminCookie(): boolean {
  if (typeof document === 'undefined') return false
  return document.cookie
    .split(';')
    .map((c) => c.trim())
    .some((c) => c.startsWith(`${ADMIN_COOKIE}=`))
}

export interface AuthState {
  readonly authenticated: boolean
}

export function getAuthState(): AuthState {
  return { authenticated: hasAdminCookie() }
}
